import StoreLocatorBase from '../../../common/StoreLocatorBase';
import Helper from '../../../../common/utils/helper';

class StoreLocator extends StoreLocatorBase {
    initMap() {
        return super.initMap().then(() => {
            const activeBranch = StoreLocator.getActiveBranch();
            let url = activeBranch.getAttribute('data-href');
            // a la premiere instanciation on va chercher tous les points.
            if (activeBranch !== undefined) {
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ id: '0' }),
                    headers: Helper.createFetchHeader(),
                })
                .then((response) => Promise.all([response, response.text()]))
                .then(([, markerList]) => {
                    this.deleteMarkers();
                    this.addMarkers(markerList);
                    this.boundMap();
                });
            }
        });
    }

    static getActiveBranch() {
        const element = document.querySelector('ul.categories-branch > li.active') as HTMLElement;
        return element || undefined;
    }

    initMarkers() {
        const self = this;
        document.querySelectorAll('.category-branch').forEach((branch: HTMLElement) => {
            branch.addEventListener('click', () => {
                (document.querySelector('.category-branch.active') as HTMLElement).classList.remove('active');
                branch.classList.add('active');
                const branchId = branch.getAttribute('data-id');
                fetch(branch.getAttribute('data-href'), {
                    method: 'POST',
                    body: JSON.stringify({ id: branchId }),
                    headers: Helper.createFetchHeader(),
                })
                    .then((response) => Promise.all([response, response.text()]))
                    .then(([, markerList]) => {
                        self.deleteMarkers();
                        self.addMarkers(markerList);
                    });
            });
        });
    }
}

// On document ready
document.addEventListener('DOMContentLoaded', () => {
    (() => new StoreLocator())();
});
